import type { DateTimePickerChangeEvent } from '@expo/ui/community/datetime-picker';
import { isAfter, isBefore, startOfDay } from 'date-fns';

export const MS_PER_MINUTE = 60_000;

export const fromAndroidPickerTimestamp = (
  timestamp: number,
  utcOffsetMinutes: number,
): Date => {
  return new Date(timestamp - utcOffsetMinutes * MS_PER_MINUTE);
};

export const fromAndroidPickerEvent = (
  event: DateTimePickerChangeEvent,
): Date => {
  const { timestamp, utcOffset } = event.nativeEvent;
  return fromAndroidPickerTimestamp(timestamp, utcOffset);
};

export const toAndroidPickerDate = (
  date: Date,
  timezoneOffsetMinutes: number = date.getTimezoneOffset(),
): Date => {
  return new Date(date.getTime() - timezoneOffsetMinutes * MS_PER_MINUTE);
};

export const getInitialPickerDate = (
  selectedDate?: Date,
  maximumDate?: Date,
  minimumDate?: Date,
): Date => {
  if (!selectedDate || isNaN(selectedDate.getTime())) {
    return maximumDate ?? new Date();
  }
  if (
    maximumDate &&
    isAfter(startOfDay(selectedDate), startOfDay(maximumDate))
  ) {
    return maximumDate;
  }
  if (
    minimumDate &&
    isBefore(startOfDay(selectedDate), startOfDay(minimumDate))
  ) {
    return minimumDate;
  }
  return selectedDate;
};

export const asHTMLElement = (node: unknown): HTMLElement | null => {
  return node instanceof HTMLElement ? node : null;
};
